import React from 'react';
import { Box, Divider } from '@mui/material';
import { BookingsTable } from '../../components/tables';

const BookingPage: React.FC = () => (
  <Box sx={{ p: 2 }}>
    <BookingsTable standalone showHeader />
    <Divider sx={{ my: 2 }} />
  </Box>
);

export default BookingPage;
